import { EVENTS } from '@/lib/consts.ts'
import { useEmitter } from '@/composables/emitter'
import { useLogger } from '@booksy-com/vue-tools'

const { emit } = useEmitter()
const logger = useLogger('event-bus')

export function modalOpen (name: string, data: unknown): Promise<unknown> {
  logger.info('open modal', name, data)
  return new Promise((resolve, reject) => {
    // prevent from rejecting with undefined
    const modalReject = (...args: unknown[]): void => {
      if (args.length) {
        ;(reject as (...reasons: unknown[]) => void)(...args)
      } else {
        reject('[event-bus-modal] closed')
      }
    }
    emit(name, { resolve, reject: modalReject, data })
  })
}

export function handleWebViewPushOpen (data: unknown): void {
  logger.info(EVENTS.WEB_VIEW_PUSH_OPEN, data)
  emit(EVENTS.WEB_VIEW_PUSH_OPEN, data)
}

export function handleWebViewResume (): void {
  logger.info(EVENTS.WEB_VIEW_RESUME)
  emit(EVENTS.WEB_VIEW_RESUME)
}

export function appointmentCalendarEvent (name: string, data: unknown): void {
  logger.info('store/appointment event to calendar', name, data)
  emit(name, data)
}
